import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45if_45not_45authroized_45global from "/opt/buildhome/repo/middleware/01-redirectIfNotAuthroized.global.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45if_45not_45authroized_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}